import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, TextField, Button, Typography, Alert } from '@mui/material';

import { loginAdmin } from '../../actions/adminAuth';

const AdminLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminAuth = useSelector(state => state.adminAuth);

  const [data, setData] = useState({ email: '', password: '' });
  const [errores, setErrores] = useState({});
  const [enviando, setEnviando] = useState(false);

  // Si ya hay sesión de admin, entra directo al panel.
  useEffect(() => {
    if (adminAuth.token) navigate('/admin');
  }, [adminAuth.token, navigate]);

  const onChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!data.email) errs.email = 'El correo es obligatorio';
    if (!data.password) errs.password = 'La contraseña es obligatoria';
    setErrores(errs);
    if (Object.keys(errs).length) return;

    setEnviando(true);
    await dispatch(loginAdmin(data.email, data.password));
    setEnviando(false);
  };

  const errorServidor = adminAuth.error?.[0]?.msg;

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'sutil', p: 2 }}>
      <Paper elevation={3} sx={{ p: 5, width: '100%', maxWidth: 420, borderRadius: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>
          Panel de administración
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
          Acceso exclusivo para administradores
        </Typography>

        {errorServidor && <Alert severity="error" sx={{ mb: 2 }}>{errorServidor}</Alert>}

        <Box component="form" onSubmit={onSubmit} noValidate>
          <TextField
            fullWidth label="Correo" name="email" type="email"
            value={data.email} onChange={onChange}
            error={!!errores.email} helperText={errores.email}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth label="Contraseña" name="password" type="password"
            value={data.password} onChange={onChange}
            error={!!errores.password} helperText={errores.password}
            sx={{ mb: 3 }}
          />
          <Button type="submit" fullWidth variant="contained" disabled={enviando} sx={{ py: 1.2 }}>
            {enviando ? 'Entrando…' : 'Iniciar sesión'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AdminLogin;
